var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useHotspot } from '../context/HotspotContext';
import { useLanguage } from '../context/LanguageContext';
import { useAppState } from '../context/AppStateContext';
import Hotspot from './Hotspot';
import '../../styles/Hotspot.css';
import { SceneStates } from '../../datas/constants';
export default function Hotspots(props) {
    var hotspots = useHotspot().hotspots;
    var language = useLanguage().language;
    var sceneState = useAppState().sceneState;
    var _a = useState(false), isShown = _a[0], setIsShown = _a[1];
    var _b = useState(""), launchBtn = _b[0], setLaunchBtn = _b[1];
    var _c = useState({}), hotspotData = _c[0], setHotspotData = _c[1];
    var filePath = "./Ressources/textes/".concat(sceneState, "_").concat(language, ".json");
    useEffect(function () {
        if (sceneState === SceneStates.INTRO) {
            fetch(filePath)
                .then(function (response) { return response.json(); })
                .then(function (data) {
                var map = {};
                data.hotspots.forEach(function (hs) { return map[hs.name] = hs; });
                setHotspotData(map);
                setLaunchBtn(data.launchButton);
            })
                .catch(function (err) { return console.error('[Hotspots] fetch FAILED:', err); });
        }
    }, [language, sceneState]);
    useEffect(function () {
        if (sceneState === SceneStates.INTRO)
            setIsShown(true);
    }, [sceneState]);
    return (_jsx("div", __assign({ className: "introUI", style: { display: isShown ? 'flex' : 'none' } }, { children: hotspots.map(function (hs) {
            var data = hotspotData[hs.name];
            if (!data)
                return null;
            return (_jsx(Hotspot, { name: hs.name, className: data.className, title: data.title, subtitle: data.subtitle, launchBtn: launchBtn, changeScene: props.changeScene, setIsShown: setIsShown, certifications: data.certifications, backgroundImg: "./imgs/".concat(hs.name, "_intro_popup.png") }, hs.name));
        }) })));
}
